import { render, staticRenderFns } from "./TrainingPlanItemPlaceholder.vue?vue&type=template&id=3b4ca07f&scoped=true&"
import script from "./TrainingPlanItemPlaceholder.vue?vue&type=script&lang=ts&"
export * from "./TrainingPlanItemPlaceholder.vue?vue&type=script&lang=ts&"
import style0 from "./TrainingPlanItemPlaceholder.vue?vue&type=style&index=0&id=3b4ca07f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b4ca07f",
  null
  
)

export default component.exports